// TSS vite/03 §"Query keys convention".

export const labKeys = {
    all:    ['labs'],
    list:   (filters) => ['labs', 'list', filters],
    detail: (id)      => ['labs', 'detail', id],
};
